import config from 'src/config';

loggerService.$inject = [
  'jsSdk.managementUser'
];

export default function loggerService(managementUserService) {
  class LoggerService {
    init() {
      if (this._rollbarInitialized) return;

      const currentUser = managementUserService.getCurrentUser();

      if (currentUser && window.Rollbar) {
        window.Rollbar.configure({
          accessToken: config.ROLLBAR_ACCESS_TOKEN,
          enabled: config.ROLLBAR_ENABLE,
          payload: {
            person: {
              id: currentUser.id,
              username: `${currentUser.firstName} ${currentUser.lastName}`,
              email: currentUser.email
            },
            environment: config.NODE_ENV || 'development',
            client: {
              javascript: {
                source_map_enabled: true,
                code_version: config.COMMIT_HASH,
                guess_uncaught_frames: true
              }
            }
          }
        });

        this._rollbarInitialized = true;
      } else {
        this._rollbarInitialized = false;
      }
    }

    error(msg) { //eslint-disable-line
      if (!msg) throw new Error('loggerService - error() - msg is required');

      // Rollbar.error(msg);
    }
  }

  return new LoggerService();
}



// WEBPACK FOOTER //
// ./src/services/loggerService.js